// extracted by mini-css-extract-plugin
export default {"Form":"pagesAdministration_Form__FPlQ2","TitleField":"pagesAdministration_TitleField__nbu7F","FormFooter":"pagesAdministration_FormFooter__fD+gx"};